import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { NgOptimizedImage } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Card } from '../../../../../_interfaces/cards.interface';
import { OffcanvasHeaderBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { OffcanvasCancelBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-cancel-btn/offcanvas-cancel-btn.component';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';

@Component({
  selector: 'app-remove-subscription-card',
  imports: [NgOptimizedImage, OffcanvasHeaderBtnComponent, OffcanvasCancelBtnComponent, OffcanvasBaseComponent],
  templateUrl: './remove-subscription-card.component.html',
})
export class RemoveSubscriptionCardComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly offcanvasService = inject(OffcanvasService);
  readonly toastService = inject(ToastService);
  readonly cardsApiService = inject(CardsApiService);

  readonly subscriptions = new Subscription();
  readonly cardId: number;
  protected cardDetails?: Card;
  protected returnUrl: string = '/cards/subscription-cards';

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.cardsApiService.getSubscriptionCardById(this.cardId).subscribe((data) => (this.cardDetails = data)),
    );
  }

  onRemoveCard() {
    this.subscriptions.add(
      this.cardsApiService.removeSubscriptionCard(this.cardId).subscribe({
        next: () => {
          this.toastService.show('You have removed a subscription card.', 'iconoir-check-circle');
          this.offcanvasService.close(this.returnUrl);
        },
        error: (error) => {
          this.toastService.show(`Something went wrong. ${error.error.card}`, 'iconoir-xmark');
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
